export class ReportStatusBusquedaModel {


    fecha_captura_inicio: string;
    fecha_captura_fin: string;
    fecha_modificacion_inicio: string;
    fecha_modificacion_fin: string;
    
}
